module.exports = __webpack_public_path__ + "img/worm_gear_cylinder_left.prt.59579f9d.jpg";